import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const defaultNegativeFeedbackPopoverBodyOptions = [{
  value: 'incorrectAction',
  label: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.options.incorrectAction`
  })
}, {
  value: 'notRelevant',
  label: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.options.notRelevant`
  })
}, {
  value: 'incomplete',
  label: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.options.incomplete`
  })
}, {
  value: 'inaccurate',
  label: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.options.inaccurate`
  })
}, {
  value: 'other',
  label: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.options.other`
  })
}];
const FeedbackButtons = ({
  selectedOptions,
  onOptionSelect,
  negativeFeedbackPopoverBodyOptions = defaultNegativeFeedbackPopoverBodyOptions
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: negativeFeedbackPopoverBodyOptions.map(option => {
      if (isNaN(Number(option))) {
        return /*#__PURE__*/_jsx(Button, {
          "data-test-id": "feedback-button",
          size: "xs",
          use: selectedOptions.includes(option.value) ? 'tertiary-light' : 'tertiary-extra-light',
          responsive: true,
          onClick: () => onOptionSelect(option.value),
          children: option.label
        }, option.value);
      }
      return null;
    })
  });
};
export default FeedbackButtons;